import React from 'react';
import SIcon from './SIcon';
import { faTrash } from '@fortawesome/pro-regular-svg-icons';

const Icon = props => <SIcon {...props} icon={faTrash} fa />;

export default Icon;
